export enum CartResponseStatus {
  Error = 'Error',
  Exception = 'Exception',
  OK = 'OK',
}

export type DResponse = {
  d: string;
};

export type CartParsedResponse = {
  _Status?: CartResponseStatus;
  _Message?: string;
  _Data?: number;
};

export type UpdateCartParsedResponse = {
  _Status?: CartResponseStatus;
  _Message?: string;
};

export type CardMessageParsedResponse = {
  _Status?: CartResponseStatus;
  _Data: string;
};
